export default __webpack_public_path__ + "static/media/icon-stop-fill.6224aa0a.svg";